/**
 * Shipping Countdown Timer
 * Handles countdown timers for shipping cutoffs and updates delivery information
 */
document.addEventListener('DOMContentLoaded', function () {
  // Find all shipping countdown elements
  const countdownElements = document.querySelectorAll('[id^="shipping-countdown-"]');

  if (countdownElements.length > 0) {
    function calculateDeliveryDay(cutoffDate, dayNumber) {
      // Calculate delivery day (add specified number of days after cutoff)
      let deliveryDate = new Date(cutoffDate);
      deliveryDate.setDate(deliveryDate.getDate() + dayNumber);

      // Skip Sunday (day 0) - move to Monday
      // This handles the case where delivery would fall on Sunday -> skip to Monday
      if (deliveryDate.getDay() === 0) {
        deliveryDate.setDate(deliveryDate.getDate() + 1);
      }

      return deliveryDate;
    }

    function formatDeliveryDate(date) {
      const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      const dayName = days[date.getDay()];
      const day = date.getDate();
      const month = months[date.getMonth()];

      // Add ordinal suffix to day
      const daySuffix = day === 1 || day === 21 || day === 31 ? 'st' : day === 2 || day === 22 ? 'nd' : day === 3 || day === 23 ? 'rd' : 'th';

      return `${dayName.substring(0, 3)} ${day}${daySuffix} ${month}`;
    }

    function updateDeliveryInfo(cutoffDate, dayNumber) {
      const deliveryDate = calculateDeliveryDay(cutoffDate, dayNumber);
      const deliveryDateFormatted = formatDeliveryDate(deliveryDate);
      const deliveryDay = deliveryDate.toLocaleDateString('en-US', { weekday: 'long' });

      // Update all delivery date and delivery day elements
      const deliveryDateElements = document.querySelectorAll('.delivery-date');
      const deliveryDayElements = document.querySelectorAll('.delivery-day');

      deliveryDateElements.forEach((el) => (el.textContent = deliveryDateFormatted));
      deliveryDayElements.forEach((el) => (el.textContent = deliveryDay));
    }

    function updateCountdown() {
      const now = new Date();
      countdownElements.forEach(function (countdownEl) {
        const cutoffHour = parseInt(countdownEl.dataset.cutoffHour || '23', 10);
        const dayNumber = parseInt(countdownEl.dataset.dayNumber || '1', 10);

        let cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour, 0, 0);

        // If current time is past today's cutoff, use tomorrow's cutoff
        if (now >= cutoff) {
          cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, cutoffHour, 0, 0);
        }

        const t = cutoff - now;
        if (t >= 0) {
          const totalHours = Math.floor(t / (1000 * 60 * 60));
          const hours = totalHours % 24;
          const minutes = Math.floor((t / (1000 * 60)) % 60);
          const seconds = Math.floor((t / 1000) % 60);

          // Always show hours within the 24-hour cycle
          countdownEl.innerHTML = `${hours}hrs ${minutes}m ${seconds}s`;
        } else {
          // If time has passed, calculate next day's cutoff
          cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, cutoffHour, 0, 0);
          const nextT = cutoff - now;

          const totalHours = Math.floor(nextT / (1000 * 60 * 60));
          const hours = totalHours % 24;
          const minutes = Math.floor((nextT / (1000 * 60)) % 60);
          const seconds = Math.floor((nextT / 1000) % 60);
          countdownEl.innerHTML = `${hours}hrs ${minutes}m ${seconds}s`;
        }

        // Always update delivery info based on current cutoff and day number
        updateDeliveryInfo(cutoff, dayNumber);
      });
    }

    // Initialize delivery info on page load
    const now = new Date();
    const cutoffHour = parseInt(countdownElements[0]?.dataset.cutoffHour || '23', 10);
    const dayNumber = parseInt(countdownElements[0]?.dataset.dayNumber || '1', 10);
    let initialCutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour, 0, 0);

    if (now >= initialCutoff) {
      initialCutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, cutoffHour, 0, 0);
    }

    updateDeliveryInfo(initialCutoff, dayNumber);
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }
});
